/* Glucose Display redesign sections. No network, storage or tracking.
   Photo dialog, gallery strip status/arrow keys, and the mobile buy bar. */
(function () {
  'use strict';
  // Several sections include this file; run the wiring once per page.
  if (window.__gdSiteReady) return;
  window.__gdSiteReady = true;
  var doc = document;

  /* ---------- Photo dialog (hero "View photos") ---------- */
  doc.querySelectorAll('[data-gd-photo-open]').forEach(function (opener) {
    var d = doc.getElementById(opener.getAttribute('aria-controls'));
    if (!d || typeof d.showModal !== 'function') return;
    var track = d.querySelector('.gd-photo-track');
    var prev = d.querySelector('[data-gd-photo-prev]');
    var next = d.querySelector('[data-gd-photo-next]');
    var status = d.querySelector('[data-gd-photo-status]');
    var close = d.querySelector('[data-gd-photo-close]');
    var index = 0, count = track.children.length, oldOverflow = '';

    function update() {
      index = Math.max(0, Math.min(count - 1, Math.round(track.scrollLeft / track.clientWidth)));
      prev.disabled = index === 0;
      next.disabled = index === count - 1;
      status.textContent = (index + 1) + ' / ' + count;
    }
    function move(i) {
      track.scrollTo({ left: Math.max(0, Math.min(count - 1, i)) * track.clientWidth, behavior: 'instant' });
      update();
    }
    opener.addEventListener('click', function () {
      oldOverflow = doc.documentElement.style.overflow;
      doc.documentElement.style.overflow = 'hidden';
      d.showModal();
      d.querySelectorAll('img').forEach(function (img) { img.loading = 'eager'; });
      move(0);
      close.focus();
    });
    close.addEventListener('click', function () { d.close(); });
    d.addEventListener('close', function () {
      doc.documentElement.style.overflow = oldOverflow;
      opener.focus({ preventScroll: true });
    });
    d.addEventListener('click', function (e) {
      if (e.target === d) {
        var r = d.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) d.close();
      }
    });
    prev.addEventListener('click', function () { move(index - 1); });
    next.addEventListener('click', function () { move(index + 1); });
    track.addEventListener('scroll', update, { passive: true });
    d.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); move(index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); move(index - 1); }
      if (e.key === 'Home') { e.preventDefault(); move(0); }
      if (e.key === 'End') { e.preventDefault(); move(count - 1); }
    });
    window.addEventListener('resize', function () { if (d.open) move(index); });
  });

  /* ---------- Gallery strip: screen-reader status and arrow keys only ----------
     Touch and trackpad swipes are native CSS scroll snap. Nothing autoplays and
     no wheel or touch events are intercepted. */
  doc.querySelectorAll('[data-gd-swipe]').forEach(function (swipe) {
    var track = swipe.querySelector('.gd-swipe__track');
    var cards = Array.prototype.slice.call(track.querySelectorAll('.gd-swipe__card'));
    var status = swipe.querySelector('.gd-swipe__status');
    var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
    var current = 0, raf = null;
    function startPad() { return parseFloat(getComputedStyle(track).paddingLeft) || 0; }
    function targetLeft(i) { return Math.max(0, cards[i].offsetLeft - startPad()); }
    function indexFromScroll() {
      var left = track.scrollLeft, best = 0, bestDist = Infinity;
      cards.forEach(function (c, i) { var d = Math.abs(targetLeft(i) - left); if (d < bestDist) { bestDist = d; best = i; } });
      return best;
    }
    function render() {
      raf = null;
      current = indexFromScroll();
      if (status) status.textContent = 'View ' + (current + 1) + ' of ' + cards.length;
    }
    function go(i) {
      i = Math.max(0, Math.min(cards.length - 1, i));
      track.scrollTo({ left: targetLeft(i), behavior: reduce.matches ? 'auto' : 'smooth' });
    }
    track.addEventListener('keydown', function (e) {
      if (e.target !== track) return;
      var n = null;
      if (e.key === 'ArrowRight') n = current + 1;
      else if (e.key === 'ArrowLeft') n = current - 1;
      else if (e.key === 'Home') n = 0;
      else if (e.key === 'End') n = cards.length - 1;
      if (n !== null) { e.preventDefault(); go(n); }
    });
    track.addEventListener('scroll', function () { if (raf === null) raf = window.requestAnimationFrame(render); }, { passive: true });
    window.addEventListener('resize', function () { if (raf === null) raf = window.requestAnimationFrame(render); });
    render();
  });


  /* ---------- Header: mobile menu ---------- */
  var head = doc.querySelector('[data-gd-head]');
  var menuBtn = doc.querySelector('[data-gd-menu-btn]');
  var nav = doc.getElementById('gd-site-nav');
  function setMenu(open) {
    if (!head || !menuBtn) return;
    head.classList.toggle('is-open', open);
    menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  if (head && menuBtn && nav) {
    menuBtn.addEventListener('click', function () { setMenu(menuBtn.getAttribute('aria-expanded') !== 'true'); });
    nav.addEventListener('click', function (e) { if (e.target.closest('a')) setMenu(false); });
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape' && head.classList.contains('is-open')) { setMenu(false); menuBtn.focus(); } });
    doc.addEventListener('click', function (e) { if (head.classList.contains('is-open') && !head.contains(e.target)) setMenu(false); });
    var wide = window.matchMedia('(min-width: 1200px)');
    wide.addEventListener('change', function () { var focused = nav.contains(doc.activeElement); setMenu(false); if (focused && !wide.matches) menuBtn.focus(); });
  }

  /* ---------- Setup: provider chooser ---------- */
  doc.querySelectorAll('[data-gd-chooser]').forEach(function (chooser) {
    var opts = Array.prototype.slice.call(chooser.querySelectorAll('.gd-chooser__opt'));
    var result = chooser.querySelector('.gd-chooser__result');
    var panels = Array.prototype.slice.call(chooser.querySelectorAll('.gd-checklist'));
    opts.forEach(function (opt) {
      opt.addEventListener('click', function () {
        var key = opt.getAttribute('data-provider');
        opts.forEach(function (o) { var sel = o === opt; o.setAttribute('aria-pressed', sel ? 'true' : 'false'); o.setAttribute('aria-expanded', sel ? 'true' : 'false'); });
        var selected;
        panels.forEach(function (c) { c.hidden = c.getAttribute('data-panel') !== key; if (!c.hidden) selected = c; });
        if (result) result.hidden = false;
        if (selected) {
          var first = selected.querySelector('li') || selected;
          var top = head ? head.getBoundingClientRect().bottom : 0;
          var barEl = doc.querySelector('[data-gd-buy-bar]');
          var bottom = barEl && getComputedStyle(barEl).display !== 'none' ? barEl.getBoundingClientRect().top : window.innerHeight;
          if (selected.getBoundingClientRect().top < top || first.getBoundingClientRect().bottom > bottom - 16) {
            var optionsTop = chooser.querySelector('.gd-chooser__options').getBoundingClientRect().top;
            window.scrollTo({ top: window.scrollY + optionsTop - top - 20, behavior: 'instant' });
          }
        }
      });
    });
  });

  /* ---------- Reviews: clamp long text; manual carousel on desktop ---------- */
  var bodies = Array.prototype.slice.call(doc.querySelectorAll('.gd-review__body[data-gd-clamp]'));
  function fitReview(body) {
    var para = body.querySelector('p') || body;
    var btn = body.parentNode.querySelector('.gd-review__more');
    if (body.classList.contains('is-open')) return;
    body.classList.add('is-clamped');
    var over = para.scrollHeight > para.clientHeight + 2;
    if (!over) body.classList.remove('is-clamped');
    if (btn) btn.hidden = !over;
  }
  function fitAll() { bodies.forEach(fitReview); }
  if (bodies.length) {
    bodies.forEach(function (body) {
      var btn = body.parentNode.querySelector('.gd-review__more');
      if (!btn) return;
      var label = btn.textContent;
      btn.addEventListener('click', function () {
        var open = !body.classList.contains('is-open');
        body.classList.toggle('is-open', open);
        body.classList.toggle('is-clamped', !open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? 'Show less' : label;
      });
    });
    var t = null;
    window.addEventListener('resize', function () { window.clearTimeout(t); t = window.setTimeout(fitAll, 120); });
    fitAll();
  }
  doc.querySelectorAll('[data-gd-reviews]').forEach(function (wrap) {
    var track = wrap.querySelector('.gd-review-list');
    var cards = Array.prototype.slice.call(track.children);
    var prev = wrap.querySelector('[data-gd-review-prev]');
    var next = wrap.querySelector('[data-gd-review-next]');
    var pos = wrap.querySelector('.gd-review-position');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!cards.length) return;
    function left(i) { return cards[i].offsetLeft - cards[0].offsetLeft; }
    function index() { var idx = 0, dist = Infinity; cards.forEach(function (c, i) { var d = Math.abs(left(i) - track.scrollLeft); if (d < dist) { idx = i; dist = d; } }); return idx; }
    function size() { var first = index(), last = window.innerWidth >= 960 ? Math.min(first + 1, cards.length - 1) : first, h = 0; for (var i = first; i <= last; i++) h = Math.max(h, cards[i].offsetHeight); track.style.height = (h + 12) + 'px'; }
    function update() { size(); var end = track.scrollWidth - track.clientWidth; if (prev) prev.setAttribute('aria-disabled', track.scrollLeft < 2 ? 'true' : 'false'); if (next) next.setAttribute('aria-disabled', track.scrollLeft >= end - 2 ? 'true' : 'false'); if (pos) pos.textContent = 'Review ' + (index() + 1) + ' of ' + cards.length; }
    function move(i) { i = Math.max(0, Math.min(cards.length - 1, i)); track.scrollTo({ left: left(i), behavior: reduce.matches ? 'auto' : 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { if (prev.getAttribute('aria-disabled') !== 'true') move(index() - 1); });
    if (next) next.addEventListener('click', function () { if (next.getAttribute('aria-disabled') !== 'true') move(index() + 1); });
    track.addEventListener('keydown', function (e) { if (e.target !== track) return; var i = index(); if (e.key === 'ArrowRight') i++; else if (e.key === 'ArrowLeft') i--; else if (e.key === 'Home') i = 0; else if (e.key === 'End') i = cards.length - 1; else return; e.preventDefault(); move(i); });
    if (window.ResizeObserver) { var ro = new ResizeObserver(size); cards.forEach(function (c) { ro.observe(c); }); }
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* ---------- Mobile buy bar ----------
     Shown only after the hero Buy button has scrolled above the header, never
     merely because it starts below the fold. The bar's button submits the hero's
     real product form so there is one add-to-cart path. */
  var heroForm = doc.querySelector('[data-gd-hero-form]');
  var heroBuy = heroForm ? heroForm.querySelector('[type="submit"]') : null;
  var bar = doc.querySelector('[data-gd-buy-bar]');
  var hero = doc.querySelector('.gd-hero');
  if (heroBuy && bar && hero) {
    var header = doc.querySelector('.section-header, .shopify-section-header, .shopify-section-group-header-group');
    var frame = null;
    function headerBottom() {
      if (!header) return 0;
      var pos = getComputedStyle(header).position;
      if (pos !== 'sticky' && pos !== 'fixed') return 0;
      return Math.max(0, header.getBoundingClientRect().bottom);
    }
    function previewBarHeight() {
      // Shopify's theme-preview bar is fixed to the bottom; sit above it so the buy bar stays visible.
      // The wrapper is a full-height overlay whose visible strip is ~64px; it exists only in theme preview.
      return doc.getElementById('PBarNextFrameWrapper') || doc.getElementById('preview-bar-iframe') ? 72 : 0;
    }
    function update() {
      frame = null;
      var passed = heroBuy.getBoundingClientRect().bottom <= headerBottom();
      var show = passed && window.innerWidth < 900;
      var offset = previewBarHeight();
      bar.style.bottom = offset ? offset + 'px' : '';
      bar.classList.toggle('is-hidden', !show);
      doc.body.style.paddingBottom = show ? (76 + offset) + 'px' : '';
    }
    function schedule() { if (frame === null) frame = window.requestAnimationFrame(update); }
    ['scroll', 'resize', 'hashchange', 'pageshow', 'load'].forEach(function (ev) { window.addEventListener(ev, schedule, { passive: true }); });
    if (window.ResizeObserver) new ResizeObserver(schedule).observe(hero);
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(schedule);
    bar.querySelector('[data-gd-buy-proxy]').addEventListener('click', function () {
      if (heroBuy.disabled || heroBuy.getAttribute('aria-disabled') === 'true') return;
      var choice = doc.querySelector('.gd-color-choice'); if (choice) { choice.scrollIntoView({behavior:'smooth',block:'center'}); var selected = choice.querySelector('input:checked'); if(selected) selected.focus({preventScroll:true}); } else { hero.scrollIntoView({behavior:'smooth',block:'start'}); }
    });
    update();
  }
})();
